import React, { SVGProps } from 'react';

export const PurchaseIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        height="20"
        id="mask0_702_48"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="20"
        x="2"
        y="2"
      >
        <path
          clipRule="evenodd"
          d="M3 7.5H21L20 21H4L3 7.5Z"
          fill="white"
          fillRule="evenodd"
          stroke="white"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M8 9.5V3H16V9.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M8 17H16"
          stroke="black"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </mask>
      <g mask="url(#mask0_702_48)">
        <path d="M0 0H24V24H0V0Z" fill="white" />
      </g>
    </svg>
  );
};
